import { render } from "./inquiryModel.vue?vue&type=template&id=262bd01d&scoped=true"
import script from "./inquiryModel.vue?vue&type=script&lang=js"
export * from "./inquiryModel.vue?vue&type=script&lang=js"

import "./inquiryModel.vue?vue&type=style&index=0&id=262bd01d&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262bd01d"]])

export default __exports__